import { ComponentPropsWithRef, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { pluralize } from '@givebutter/util';
import { LinkedResourceText } from 'components/tasks/LinkedResourceText';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';
import { TaskLinkable } from 'types/domain';

interface LinkedResourceLinksProps extends ComponentPropsWithRef<'p'> {
    links: TaskLinkable[];
    onClickLink?: () => void;
}

const LinkedResourceLinks = ({
    className,
    links,
    onClickLink,
    ...rest
}: LinkedResourceLinksProps) => {
    const { accountId } = useCurrentAccount();

    const displayed = links.slice(0, 2);
    const hidden = links.slice(2);

    if (!links.length) return null;

    return (
        <p className={twMerge('z-layerFour relative text-sm text-gray-600', className)} {...rest}>
            {displayed.map(({ linkable_id, linkable, linkable_type: type }, index) => {
                return (
                    <Fragment key={`${type}/${linkable_id}`}>
                        <Link
                            to={`/accounts/${accountId}/${type}s/${linkable_id}`}
                            onClick={e => {
                                e.stopPropagation();
                                onClickLink?.();
                            }}
                        >
                            <LinkedResourceText type={type} linkable={linkable} />
                        </Link>
                        {displayed.length > 1 && (index + 1 < displayed.length || hidden.length > 0)
                            ? ', '
                            : ' '}
                    </Fragment>
                );
            })}

            {hidden.length
                ? `and ${hidden.length} more linked ${pluralize(hidden.length, 'page')}`
                : null}
        </p>
    );
};

export { LinkedResourceLinks };
